import { useIdentity } from '$api-clients/hooks';

export const useHasAccessToCreateTeamMember = () => {
  const { data: userinfo } = useIdentity('/auth/userinfo');

  const uniqueRoles = [
    ...new Set(userinfo?.teams.flatMap((team) => team.roles)),
  ];

  return uniqueRoles.includes('LEAD') || uniqueRoles.includes('MEMBER');
};
